import { SxProps } from '@mui/material';

export const LoadingStyles: SxProps = {
    display: 'flex',
    justifyContent: 'center',
    margin: '100px 0',
};

export const ButtonLoadingStyles: SxProps = {
    marginLeft: '6px',
};
